export default __webpack_public_path__ + "static/media/640_business03-en-mobile.dc279063.png";